<template>
  <div class="ec-navigation" :class="{'calculation-finished': isFinishModule}">
    <div class="ec-navigation-back-btn-wrapper">
      <a 
        :class="{'disabled': isLoading}" 
        class="btn is-super-primary is-small" 
        @click="prev">
        <i 
          aria-hidden="true" 
          class="fa fa-angle-left" 
          style="margin-right: 5px;"/>
        <span v-show="this.$store.page.isFirstPage">Startseite</span>
        <span v-show="!this.$store.page.isFirstPage">Zurück</span>
      </a>
    </div>
    <div class="continue-container">
      <a 
        v-show="isJumpToEndEnabled"
        :class="{'disabled': isNextDisabled}"
        class="btn is-super-primary is-small back-to-end-btn" 
        @click.prevent="jumpToEnd">Zurück zum Ende</a>
      <a
        v-show="!isFinishModule"
        :class="{'disabled': isNextDisabled}"
        class="btn is-super-primary is-small" 
        @click.prevent="next">Weiter <i
          aria-hidden="true" 
          class="fa fa-angle-right" 
          style="margin-left: 5px;"/></a>
      <a v-show="isFinishModule"
        id="finish-show-overview-btn"
        class="btn is-blue"
        @click.prevent="calculationOverviewModal">Ergebnis anzeigen</a>
    </div>
  </div>
</template>
<script>
  import {get} from 'lodash'
  import {redirect} from '../utility'

    export default {
        name: "Navigation",
        props: {
            isRdyToSend: {
                type: Boolean,
                default: false
            },
            isLoading: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            isNextDisabled: function() {
                if(this.$store.page.readOnly && this.$store.page.readOnly.atTheEnd) {
                    return true
                }

                return !this.isRdyToSend || this.isLoading
            },
            isJumpToEndEnabled: function() {
                if(this.$store.page && this.$store.page.jumpToEndEnabled) {
                    return true
                }

                return false
            },
            readOnly() {
                return this.$store.readOnlyCode || false
            },
            isFinishModule() {
                const type = get(this.$store, 'page.module.type', false)

                return (type && type === 'finish')
            }
        },
        created() {
            window.addEventListener('keyup', (e) => {
                if(event.target.tagName.toUpperCase() === 'BODY') {
                    if(e.keyCode === 39) {
                        this.next()
                    }

                    if(e.keyCode === 37) {
                        this.prev()
                    }
                }
            })
        },
        methods: {
            calculationOverviewModal() {
                this.$event.$emit('show-calculation-overview-modal', this.$store.calculation)
            },
            next() {
                if(!this.isNextDisabled) {
                    this.$event.$emit('next')
                }
            },
            prev() {
                if(this.$store.page.isFirstPage) {
                    redirect('/')
                    return
                }

                this.$event.$emit('prev')
            },
            jumpToEnd() {
                redirect('/' + this.$store.axiosBase + 'jump-to/end?readonly='+this.readOnly)
            }
        }
    }
</script>
